import { DisplayBox } from '@m/alchemy-ui/DisplayBox';
import { units, color, typeStyle } from '@m/alchemy-ui/theme';
import styled from 'styled-components';

export const FeedbackComponentContainer = styled(DisplayBox).attrs({
  depth: 'moduleChrome',
  hoverDepth: 'moduleChrome',
})`
  ${typeStyle('bodyS')};
  border: none;
  color: ${color('base', { palette: 'interactiveNavigational' })};
  padding: ${units(3)};
  margin: 0 auto;
  margin-top: ${units(3)};
  max-width: 920px;
  width: 100%;

  & strong {
    font-weight: 700;
  }
`;
